import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles: any = makeStyles({
  popover: {
    width: "360px",
    maxWidth: "100%",
    height: "fit-content",
  },
  card: {
    width: "280px",
    height: "fit-content",
  },
  modalImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
    display: "block",
    margin: "0 auto",
  },
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    borderLeft: `2px dashed ${designTokens.neutral[300]}`,
    boxSizing: "border-box" as const,
  },
  containerMobile: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box" as const,
  },
  chatTitle: {
    fontSize: designTokens.fontSize.xl,
    fontWeight: designTokens.fontWeight.semibold,
    textAlign: "left",
    padding: `${designTokens.spacing[2]} 0px ${designTokens.spacing[2]} ${designTokens.spacing[5]}`,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    width: "75%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  mainContainerMobile: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: designTokens.spacing[2],
    flexWrap: "wrap",
    width: "100%",
    paddingBottom: designTokens.spacing[2],
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    marginBottom: designTokens.spacing[2],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  fieldContainerMobile: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    paddingTop: designTokens.spacing[1],
    paddingBottom: designTokens.spacing[1],
    paddingLeft: 0,
    paddingRight: 0,
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    margin: 0,
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    width: "100%",
    maxWidth: "100%",
    ...shorthands.border("2px", "solid", designTokens.neutral[300]),
    ...shorthands.borderRadius(designTokens.borderRadius["2xl"]),
    boxShadow: designTokens.shadow.md,
    overflow: "hidden",
    boxSizing: "border-box",
    backgroundColor: designTokens.neutral.white,
    paddingLeft: designTokens.spacing[2],
    ":focus-within": {
      border: `2px solid ${designTokens.accent[500]}`,
    },
  },
  helperText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
    textAlign: "right",
    paddingTop: designTokens.spacing[1],
    paddingRight: designTokens.spacing[2],
  },
  topBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative" as const,
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[6],
    paddingRight: designTokens.spacing[6],
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    flexShrink: 0,
  },
  topBarMobile: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: "80px",
    paddingRight: designTokens.spacing[3],
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    flexShrink: 0,
  },
  topBarTitle: {
    position: "absolute" as const,
    left: 0,
    right: 0,
    textAlign: "center" as const,
    pointerEvents: "none" as const,
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
  },
  topBarTitleMobile: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
    whiteSpace: "nowrap" as const,
  },
  topBarRightSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  topBarSideMobile: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  topBarSideMobileEnd: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  manageContentButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "36px",
    gap: designTokens.spacing[2],
    "& > .fui-Button__icon": {
      marginRight: "2px",
    },
    paddingLeft: designTokens.spacing[3],
    paddingRight: designTokens.spacing[4],
    paddingTop: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[2],
    backgroundColor: designTokens.primary[900],
    color: designTokens.neutral.white,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium as any,
    borderRadius: designTokens.borderRadius.md,
    ":hover": {
      backgroundColor: designTokens.primary[700],
      color: designTokens.neutral.white,
    },
    ":active": {
      backgroundColor: designTokens.primary[900],
      color: designTokens.neutral.white,
    },
    ":hover:active": {
      backgroundColor: designTokens.primary[900],
      color: designTokens.neutral.white,
    },
  },
  manageContentButtonMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "34px",
    minWidth: "34px",
    paddingLeft: designTokens.spacing[2],
    paddingRight: designTokens.spacing[2],
    paddingTop: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[2],
    backgroundColor: designTokens.primary[900],
    color: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.md,
    "& > .fui-Button__icon": {
      marginRight: "0",
    },
    ":hover": {
      backgroundColor: designTokens.primary[700],
      color: designTokens.neutral.white,
    },
    ":active": {
      backgroundColor: designTokens.primary[900],
      color: designTokens.neutral.white,
    },
    ":hover:active": {
      backgroundColor: designTokens.primary[900],
      color: designTokens.neutral.white,
    },
  },
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "18px",
    height: "18px",
    backgroundColor: designTokens.accent[500],
    color: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.full,
    fontSize: "11px",
    fontWeight: designTokens.fontWeight.semibold as any,
  },
  messagesArea: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "20px",
    paddingLeft: "5rem",
    paddingRight: "5rem",
    paddingBottom: "5px",
    overflowY: "auto" as const,
    flex: 1,
    minHeight: 0,
    position: "relative" as const,
    width: "100%",
    boxSizing: "border-box" as const,
    backgroundColor: designTokens.neutral[50],
  },
  messagesAreaMobile: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "16px",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingBottom: "5px",
    overflowY: "auto" as const,
    flex: 1,
    minHeight: 0,
    position: "relative" as const,
    width: "100%",
    boxSizing: "border-box" as const,
    backgroundColor: designTokens.neutral[50],
  },
  messageBarSection: {
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[6]} ${designTokens.spacing[5]} ${designTokens.spacing[6]}`,
    backgroundColor: designTokens.neutral[50],
    boxSizing: "border-box" as const,
    width: "100%",
  },
  messageBarSectionMobile: {
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    backgroundColor: designTokens.neutral[50],
    boxSizing: "border-box" as const,
    width: "100%",
  },
  drawerContent: {
    padding: "16px",
  },
  emptyState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    flex: 1,
  },
  emptyStateText: {
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.normal as any,
    textAlign: "center" as const,
    lineHeight: "24px",
  },
  messageColumnAssistant: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    alignItems: "start",
  },
  messageColumnUser: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    alignItems: "end",
  },
  messageBodyAssistant: {
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[5]} ${designTokens.spacing[3]} 45px`,
    wordBreak: "break-word",
  },
  messageBodyUser: {
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[5]} ${designTokens.spacing[3]} 50px`,
    wordBreak: "break-word",
  },
  drawerMinWidth: {
    minWidth: "500px",
  },
  drawerMinWidthMobile: {
    minWidth: "100%",
  },
  flexWrapRow: {
    display: "flex",
    gap: designTokens.spacing[1],
    flexWrap: "wrap",
  },
  filesColumn: {
    display: "flex",
    gap: designTokens.spacing[1],
    flexWrap: "wrap",
    flexDirection: "column",
  },
  sourceDocCard: {
    width: "100%",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  citationText: {
    marginLeft: designTokens.spacing[2],
    fontSize: designTokens.fontSize.xs,
    color: tokens.colorNeutralForeground2,
  },
  sourceDocContent: {
    textAlign: "start" as const,
    color: tokens.colorNeutralForeground2,
  },
  timestamp: {
    padding: `0px 0px 0px ${designTokens.spacing[1]}`,
    color: tokens.colorNeutralForeground3,
  },
  hoverPlaceholder: {
    height: "24px",
  },
  editInput: {
    width: "60%",
  },
  centerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  fileCardFit: {
    height: "fit-content",
  },
  editActions: {
    display: "flex",
    gap: designTokens.spacing[1],
  },
});
